export default __webpack_public_path__ + "static/media/hubs.47e040b8.svg";